import { formConfig } from 'config/forms';
import { DEFAULT_LATEST, THIS_MONTH } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { getSafeDateTime, isSafeDateLater, setToStartOfMonth } from 'helpers/date';
import { SafeDateTime } from 'helpers/types';
import { isPVQForm } from 'helpers/form';
import { SubstanceDrugsPublicSafetyItemModel } from '../types';

const substanceDrugsPublicSafetyItemValidator: ValidateJSModel<SubstanceDrugsPublicSafetyItemModel> = {
  DrugType: (value, attributes, attributeName, options) => {
    const isPVQ = isPVQForm(options?.formType);
    if (isPVQ) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  DrugTypeOther: (value, attributes, attributeName, options) => {
    const isPVQ = isPVQForm(options?.formType);
    if (isPVQ) {
      if (attributes?.DrugType?.value === 'Other') {
        return { presence: true, hasValue: true };
      }
    }
    return {};
  },
  HowManyTimes: (value, attributes, attributeName, options) => {
    const isPVQ = isPVQForm(options?.formType);
    if (isPVQ) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  UseWhileEmployedPosition: (value, attributes, attributeName, options) => {
    const isPVQ = isPVQForm(options?.formType);
    if (isPVQ) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  UseWhileEmployedPositionOther: (value, attributes, attributeName, options) => {
    const isPVQ = isPVQForm(options?.formType);
    if (isPVQ) {
      if (attributes?.UseWhileEmployedPosition?.value === 'Other') { return { presence: true, hasValue: true }; }
    }
    return {};
  },
  Reason: (value, attributes, attributeName, options) => {
    const isPVQ = isPVQForm(options?.formType);
    if (isPVQ) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  Description: (value, attributes, attributeName, options) => {
    const isPVQ = isPVQForm(options?.formType);
    if (isPVQ) {
      return { };
    }
    return { presence: true, hasValue: true };
  },
  InvolvementDates: (value, attributes, attributeName, options) => {
    const formTypeConfig = options?.formType && formConfig[options?.formType as keyof typeof formConfig];
    const years: any = formTypeConfig && formTypeConfig.SUBSTANCE_DRUG_PUBLIC_SAFETY_YEARS;

    const beyondRequired: SafeDateTime = getSafeDateTime(THIS_MONTH);
    let useDuration = false;

    if (years && beyondRequired?.valid && typeof years === 'number') {
      beyondRequired.datetime = beyondRequired.datetime.minus({ years });
      useDuration = !value?.present && isSafeDateLater(beyondRequired, setToStartOfMonth(getSafeDateTime(value?.to)));
    }

    return {
      presence: true,
      daterange: {
        requireYear: false,
        earliest: useDuration ? setToStartOfMonth(beyondRequired).datetime : setToStartOfMonth(options?.applicantBirthdate),
        tooEarly: useDuration ? 'error.beforeDuration' : 'error.applicantMin',
        latest: DEFAULT_LATEST
      },
    };
  },
  EstimatedUse: (value, attributes, attributeName, options) => {
    const isPVQ = isPVQForm(options?.formType);
    if (isPVQ) {
      return { };
    }
    return { presence: true, hasValue: true };
  },
  Comments: {},
};

export default substanceDrugsPublicSafetyItemValidator;
